module.exports = __webpack_public_path__ + "assets/images/2b5ca863fc7161cb9ebb9b1fb887bf23.svg";